import PropTypes from "prop-types";
import Item from "./item";

const Page = PropTypes.shape({
  id: PropTypes.number,
  items: PropTypes.arrayOf(Item.ANY),
});

export default Page;
